import { useEffect } from "react";
import { apiFetch } from "../../../../toolympus/api/core";
import { useItemActionWithConfirmation } from "../../../../toolympus/api/useAction";
import { useEditItem2 } from "../../../../toolympus/api/useNewItem"
import { useLoadedData } from "../../../../toolympus/hooks/useLoadedData";
import { Employee } from "../../Structure/types";
import { AbsenceExtraQuota } from "./types";


export const useAbsenceExtraQuotas = () => {
  const employee = useEditItem2<Employee>({
    save: async (item) => {
      return item;
    }
  });

  const quotas = useLoadedData<AbsenceExtraQuota[]>(`/api/org/absence/extra-quota?employee=${employee.item?._id}`, [], !!employee.item?._id);

  useEffect(() => {
    if(!employee.item?._id) {
      quotas.setData([]);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employee.item?._id]);

  const addQuota = useEditItem2<Partial<AbsenceExtraQuota>>({
    save: async (item) => {
      const result = await apiFetch<AbsenceExtraQuota>(`/api/org/absence/extra-quota`, "post", item);
      quotas.reload();
      return result;
    }
  });

  const removeQuota = useItemActionWithConfirmation<AbsenceExtraQuota, AbsenceExtraQuota>(
    async (item) => {
      await apiFetch<AbsenceExtraQuota>(`/api/org/absence/extra-quota/${item._id}`, "delete");
      quotas.reload();
      return item;
    }, {
      title: "Удалить",
      memoTrigger: `${employee.item?._id}`,
    }
  )

  return {
    ...employee,
    showFor: (employeeX: Employee) => employee.startEditing(employeeX),
    quotas,

    addQuota: {
      ...addQuota,
      start: () => {
        if(employee.item?._id) {
          addQuota.startEditing({
            employee_id: employee.item?._id,
            year: new Date().getFullYear().toString(),
            kind: "dayoff",
          })
        }
      },
    },
    removeQuota,
  }
}

export type AbsenceExtraQuotasData = ReturnType<typeof useAbsenceExtraQuotas>;
